export enum KpiActionTypes {
  GET_KPI_DATA = 'GET_KPI_DATA',
  CLEAR_KPI_STATE = 'CLEAR_KPI_STATE',
  GET_GROUPED_KPI_DATA = 'GET_GROUPED_KPI_DATA',
  GET_PROSPECT_KPI_BY_IDS = 'GET_PROSPECT_KPI_BY_IDS',
}
